import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { ThemeProvider } from "@material-ui/core/styles";
import {
  createMuiTheme,
  Grid,
  Container,
  responsiveFontSizes,
  Snackbar,
  Typography,
  CircularProgress,
  Link,
} from "@material-ui/core";
import { Alert } from '@material-ui/lab';

import Header from "./Header";
import Body from "./Body";

import * as PaymentActions from "../actions/PaymentActions";

const OverLayStyle = {
  position: 'absolute',
  width: '100vw',
  height: '100vh',
  display: 'grid',
  gridTemplateColumns: 'max-content',
  gridTemplateRows: 'max-content max-content max-content',
  gridGap: '10px',
  backgroundColor: '#1d1d1dbf',
  placeContent: 'center',
  zIndex: '8',
  top: '0',
  bottom: '0',
  left: '0',
  right: '0',
}


class PaymentPage extends Component {
  componentDidMount = () => {

  }


  render = () => {
    const { snackbar, overlayOpen, actions } = this.props;
    const { closeSnackbar } = actions;

    const theme = responsiveFontSizes(
      createMuiTheme({
        palette: {
          primary: {
            main: this.props.primaryColor,
          },
        },
      })
    );

    theme.typography.h3 = { fontSize: "3.2rem" };
    theme.typography.button = { fontSize: "2.2rem" };

    return (
      <ThemeProvider theme={theme}>
        <div>
          <Header />
          <div style={{ height: "4vh" }}></div>

          <Grid container justify="center" alignItems="center" spacing={3}>
            <Grid item lg={5} md={7} sm={12} xs={12}>
              <Container>
                <Body />
              </Container>
            </Grid>
          </Grid>

          <Snackbar
            open={snackbar.open}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={snackbar.duration || 6000}
            onClose={closeSnackbar}
          >
            <Alert onClose={closeSnackbar} severity={snackbar.type} variant="filled"><Typography variant="body2">{snackbar.message}</Typography></Alert>
          </Snackbar>
          
          {!overlayOpen ? null :
          <div style={OverLayStyle}>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content', placeContent: 'center' }}>
              <CircularProgress style={{ color: '#327cb7' }} size={100} />
            </div>
            <Typography variant="h4" style={{ color: '#ffffff' }}>Please do not <strong>refresh</strong> this page</Typography>
            <Link href="#" style={{ textAlign: "center", color: '#fff' }} onClick={() => window.location.reload()}>Cancel</Link>
          </div>
          }
        </div>
      </ThemeProvider>
    );
  };
}

const mapStateToProps = ({ payment }) => ({
  primaryColor: payment.primaryColor,
  loading: payment.loading,
  snackbar: payment.snackbar,
  overlayOpen: payment.overlayOpen,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
